// extracted by mini-css-extract-plugin
export default {"fadeIn":"IFeelLuckyPopup__fadeIn--1eR","zoomIn":"IFeelLuckyPopup__zoomIn--YbN","bounceIn":"IFeelLuckyPopup__bounceIn--ZW4","bounceInAnim":"IFeelLuckyPopup__bounceInAnim--FQT"};